import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { Wave } from '../../HomePage/ShopBanner/styled';
import {
  Banner,
  BannerPara,
  BannerSubtext,
  BannerText,
  BannerWrapper,
} from './styled';

export default function ToolBanner() {
  return (
    <>
      <Banner>
        <BannerWrapper>
          <BannerText>USEFUL TOOLS</BannerText>
          <BannerSubtext>
            For every step in your parenting journey
          </BannerSubtext>
        </BannerWrapper>
        <Wave src={images.toolBannerWave} bottom={'0px'} />
      </Banner>
      <BannerPara>
        Whether you&apos;re trying to get pregnant, already pregnant, or a new
        mom, we have the tools you need to stay on top of everything. Try
        easy-to-use tools like our ovulation calculator, Vaccination Tracker,
        personalized pregnancy and baby weekly tracker, contraction calculator,
        feeding log and more.
      </BannerPara>
    </>
  );
}
